export default __webpack_public_path__ + "starwarsapi.png";